<script>
import transportAllotmentTypes from '../../variables/transportAllotmentTypes';

export default {
  name: 'NonDynamicTransportAllotmentTypes',
  props: {
    allotmentType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedType: this.allotmentType,
      hk: transportAllotmentTypes.HK,
      rq: transportAllotmentTypes.RQ,
      dummy: transportAllotmentTypes.DUMMY,
    };
  },
  methods: {
    setAllotment(allotment) {
      this.$emit('update', allotment);
    },
  },
};
</script>

<template>
  <div>
    <v-radio-group
      :value="allotmentType"
      @change="setAllotment($event)"
    >
      <v-layout row>
        <v-radio
          class="pb-3"
          :value="hk"
          :label="$t('nonDynamicTransport.labels.allotmentHK')"
        />
        <v-radio
          class="pb-3"
          :value="rq"
          :label="$t('nonDynamicTransport.labels.allotmentRQ')"
        />
        <v-radio
          class="pb-4"
          :value="dummy"
          :label="$t('nonDynamicTransport.labels.dummy')"
        />
      </v-layout>
    </v-radio-group>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportAllotmentTypes.vue